import React from "react"

function PartThreeIntro() {
    return (
        <div>
            <h3 className="phaseIntro searchIntro">The NYPD have analysed the fingerprint found at the scene. Meanwhile, I think Nigel Haysmith is hiding something. Search Nigel's office and analyse the remaining suspect fingerprints. Let's get to it and eliminate another suspect from the investigation. </h3>

             <div className="imageTextWrapper blueprintImageWrapper">
                <img className="blueprintImage" src={"images/curatorsOffice.jpg"} alt="blueprint of the curator's office" />
            </div>
        </div>
    )
}

export default PartThreeIntro